import { getApp } from '@genesislcap/foundation-shell/app';
import type { FoundationRouter } from '@genesislcap/foundation-ui';
import { css, GenesisElementLayout, html } from '@genesislcap/web-core';
import type { PbiStore } from '../store';
import bofa from '../assets/bofa.svg';
import {notificationsButton} from "../../pbc/notify/elements";
import {piMenu} from "../../pbi/components/elements";

type ClientAppRouter = FoundationRouter & { store: PbiStore };

const app = getApp();

const baseLayoutCss = css`
  .container {
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
  }

  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const defaultLayout = new GenesisElementLayout(
  html<ClientAppRouter>`
    <div class="container">'
      ${x => {
        app.deregisterElement(notificationsButton);
        app.deregisterElement(piMenu);
        app.registerElement(piMenu);
      }}
      <foundation-header
        logo-src="${bofa}"
        hide-side-bar
        show-luminance-toggle-button
        :routeNavItems=${(x) => x.config.getNavItems()}
        logout-button-position="account-menu"
        enable-inactivity-monitoring
        inactivity-timeout-minutes="600"
        inactivity-warning-minutes="1"
      >
        <account-details slot="account-menu"></account-details>
      </foundation-header>
      <div class="content">
        ${app.registerElementsTarget('content-start')}
        <slot></slot>
        ${app.registerElementsTarget(['content', 'content-end'])}
      </div>
      ${app.registerElementsTarget(['layout', 'layout-end'])}
    </div>
  `,
  css`
    ${baseLayoutCss}

    .content {
      padding-top: var(--nav-height);
    }

    foundation-header {
      z-index: 999;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: var(--nav-height);
      align-items: center;
      border: none;
    }

    rapid-tree-item rapid-icon {
      color: #879ba6;
      padding-right: 10px;
    }

    foundation-header::part(nav-visibility-icon) {
      color: var(--accent-foreground-rest);
    }

    foundation-header::part(notifications-button) {
      position: relative;
    }

    foundation-header::part(account-menu) {
      font-size: var(--type-ramp-base-font-size, 11px);
      line-height: 1.2;
      color: var(--neutral-foreground-rest);
    }

    rapid-flyout::part(flyout) {
      width: 40%;
      min-width: 320px;
      padding: 0;
    }

    rapid-flyout::part(content) {
      height: 100%;
    }
  `.withBehaviors(app.registerStylesTarget('layout')),
);
